/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowLineDownRight(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M200,100V200a8.00039,8.00039,0,0,1-8,8H92a8.00038,8.00038,0,0,1-5.65723-13.65723L130.686,150,74.34277,93.65674A8.00018,8.00018,0,1,1,85.65723,82.34326L142,138.686l44.34277-44.34278A8.0001,8.0001,0,0,1,200,100Zm16-67.99609H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" />
    </Svg>
  );
}

export default ArrowLineDownRight;
